module.exports = __webpack_public_path__ + "img/circuit.8974ef9e.png";